import { render, staticRenderFns } from "./Fase1.vue?vue&type=template&id=34899eaa&scoped=true"
import script from "./Fase1.vue?vue&type=script&lang=js"
export * from "./Fase1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34899eaa",
  null
  
)

export default component.exports